module.exports = __webpack_public_path__ + "5fd3e42973d2c376049be1bdb8c38f44.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Triangle.png
// module id = 798
// module chunks = 0